module.exports = __webpack_public_path__ + "static/media/github.cbc38ef1.svg";